import CallToActionGroup from "@/components/site-builder/CallToActionGroup";
import TextField from "@/components/site-builder/TextField";
import type { BaseSiteBuilderModule } from "@/types/site-builder";

export interface HeaderVariant2Props {
  module: BaseSiteBuilderModule;
}

export default function HeaderVariant2(props: HeaderVariant2Props) {
  const { module } = props;
  const {
    baseContent: {
      header: { preTitle, title, subTitle, intro, buttons, buttonsAlignment },
    },
    style: {
      display: { headerLayout },
    },
  } = module;

  const [leftColumn, rightColumn] = headerLayout.split(":");

  return (
    <div className="row flex-middle">
      <div className={`col-12 col-lg-${leftColumn}`}>
        <TextField field={preTitle} type="pre-title" />
        <TextField field={title} type="title" />
      </div>
      <div className={`col-12 col-lg-${rightColumn}`}>
        <TextField field={subTitle} type="sub-title" />
        <TextField field={intro} type="intro" />
        {buttons.length > 0 && (
          <CallToActionGroup buttons={buttons} position={buttonsAlignment} />
        )}
      </div>
    </div>
  );
}
